<template>
    <expandable-panel :id="`code-insights-${contentId}`" :expand="isExpanded" class="insights-expansion-panel-wrapper"
        @changeExpansion="changeExpansion">
        <template v-slot:title>
            <span class="text--secondary font-weight-bold">INSIGHTS ({{ insights.length }}) </span>
        </template>
        <template v-slot:content>
            <div class="premium-tag-category-item">
                <v-row dense align="center">
                    <v-col v-for="(item, key) in insights" :key="key" cols="auto">
                        <v-tooltip bottom open-delay="400" z-index="199" max-width="300">
                            <template v-slot:activator="{ on, attrs }">
                                <v-chip 
                                    tabindex="0"
                                    small
                                    :color="insightMappings[item.type].color"
                                    @click="selectInsight(item)"
                                    @keydown.enter="selectInsight(item)"
                                    v-bind="attrs"
                                    v-on="on">
                                    <v-icon v-if="item?.icon" size="20" class="mr-1 text--secondary">
                                        mdi-{{ item.icon }}
                                    </v-icon>
                                    <span class="black--text">
                                        {{ item.name }}
                                    </span>
                                </v-chip>
                            </template>
                            <span class="tooltip-codeinsights-text tooltip-content" v-if="item.description !== ''">
                                <v-icon v-if="item.isLocked" color="white" small class="mr-1">
                                    mdi-lock-outline
                                </v-icon>
                                {{ trimmedText(item.description) }}
                            </span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </div>
        </template>
    </expandable-panel>
</template>

<script>
import { ApiService } from "../../api/ApiService";
import ExpandablePanel from "../titles/partials/ExpandablePanel.vue";
import { EventNames } from "../../classes/EventNames";

export default {
    data: function() {
        const insightMappings = this.$getConst('insightMappings');
        return {
            sectionExpand: false,
            insightMappings,
        }
    },
    components: { ExpandablePanel },
    props: {
        contentId: {
            type: Number,
            required: true
        },
        documentId: {
            type: Number,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        sectionTitle: {
            type: String,
            required: true
        },
        insights: {
            type: Array,
            required: true
        },
        expand: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        isExpanded() {
            return this.expand || this.sectionExpand;
        }
    },
    methods: {
        changeExpansion(val) {
            this.sectionExpand = val === 0 ? true : false;
            this.$emit('toggleInsights', this.sectionExpand);
        },
        logCategoryClick() {
            const category = this.selectedCategory?.id;
            ApiService.logPremiumCategoryClick(category, this.contentId);
        },
        getInsightName(item) {
            return item.name;
        },
        selectInsight(insight) {

          this.logCategoryClick();

          if (insight.isLocked) {
            // TODO: previously this was triggered via:
            // EventBus.fire('show-tag-restricted-dialog', categoryInfo);
            // modify to remove dead code
            this.openRestrictionDialog(insight);
          } else {
            this.openInsightDialog(insight);
          }
        },

        openRestrictionDialog(insight) {
            const insightData = {
                insightId: insight.id,
                type: 'premium',
                documentId: this.documentId
            };
            EventBus.fire(EventNames.INSIGHT_RESTRICTED_DIALOG, insightData);
        },

        openInsightDialog(insight) {
            const insightDetails = {
                id: insight.id,
                contentId: this.contentId,
                sectionTitle: this.sectionTitle,
                title: this.title,
                insightName: insight.name,
                type: insight.type
            };

            const eventMap = {
                cdp: EventNames.INSIGHT_CDP_DIALOG,
                premiumcontent: EventNames.INSIGHT_PREMIUM_DIALOG,
                es: EventNames.INSIGHT_ES_ERRATA_SRCC_DIALOG,
                errata: EventNames.INSIGHT_ES_ERRATA_SRCC_DIALOG,
                srcc: EventNames.INSIGHT_ES_ERRATA_SRCC_DIALOG
            };

            const eventName = eventMap[insight.type];

            if (eventName) {
                EventBus.fire(eventName, insightDetails);
            }
        },

    }
}
</script>


<style scoped lang="scss">
    .tooltip-codeinsights-text {
        display: -webkit-box;
        -webkit-line-clamp: 2;   /* Limit to 2 lines */
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        max-width: 100%;
    }
</style>